import * as React from 'react';

import { PageSeoInfo } from 'components';
import { useProductAction, useProductValue } from 'context';

const ProductSeoInfo = () => {
  const { name, seo, ownerType } = useProductValue();
  const action = useProductAction();

  return (
    <PageSeoInfo
      seo={seo}
      ownerType={ownerType}
      defaultName={name}
      onUpdateSeoInfo={result => {
        action({
          type: 'UPDATE_PRODUCT_SEO',
          payload: {
            seo: result,
          },
        });
      }}
    />
  );
};

export { ProductSeoInfo };
